// All environments share one FullStory org — tag data with these so prd can
// be filtered without per-metric hostname rules, and regressions tied to a build.

/** Deploy stage (dev | stg | prd) from support-vars.js; `local` in dev. */
export const getAppEnvironment = (): string => window.ENVIRONMENT || 'unknown';

/** Short commit SHA of the build, injected by vite.config.ts. */
export const getAppVersion = (): string =>
  import.meta.env.VITE_APP_VERSION || 'unknown';
